<template>

  <Head :title="$t('admin.menu.roles')" />

  <AdminLayout ref="adminLayout">
    <div class="flex flex-col h-[calc(100vh-90px)] justify-between">
      <div class="flex-1 overflow-auto">
        <div class="flex">
          <div class="flex-1 search-filters">
            <el-form :model="searchModel" label-position="top">
              <div class="grid grid-cols-4 gap-2">
                <div class="col-span-1">
                  <el-form-item prop="keyword" :label="$t('admin.role.search.quickSearch')">
                    <el-input v-model="searchModel.keyword" :placeholder="$t('admin.role.search.placeholder')" />
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
          <div class="w-100 flex flex-col items-end space-y-2">
            <el-button type="primary" @click="eventHandler('search')">
              <el-icon class="mr-1"><Search /></el-icon>
              {{ $t('common.search') }}
            </el-button>
            <el-button @click="eventHandler('reset')">
              <el-icon class="mr-1"><RefreshRight /></el-icon>
              {{ $t('common.reset') }}
            </el-button>
          </div>
        </div>

        <el-divider class="!mt-[5px] !mb-[10px]" />

        <div class="flex justify-end mb-[10px]">
          <el-button type="primary" @click="openDrawer('new')">
            <el-icon class="mr-1"><Plus /></el-icon>
            {{ $t('common.add') }}
          </el-button>
        </div>

        <el-table :loading="loading" row-key="id" :data="rows" :border="false" class="w-full border-t">
          <el-table-column :label="$t('admin.role.fields.name')" min-width="135" fixed="left">
            <template #default="{ row }">
              <div class="cursor-pointer" @click="openDrawer('show', row.id)">
                <div class="text-gray-500 text-sm">ID: {{ row.id }}</div>
                <div class="text-base font-normal text-primary"> {{ row.name }} </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('admin.role.fields.permissions')" min-width="280">
            <template #default="{ row }">
              <div class="flex flex-wrap gap-1">
                <el-tag v-for="(item, index) in row.permissionTexts" :key="index" size="small">{{ item }}</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('admin.role.fields.createdAt')" prop="createdAt" width="150" />
          <el-table-column :label="$t('common.operation')" width="120" fixed="right">
            <template #default="{ row }">
              <div class="flex justify-between">
                <el-button link type="primary" @click="openDrawer('edit', row.id)">{{ $t('common.edit') }}</el-button>
                <el-popconfirm :title="$t('common.confirmDelete')" type="warning"
                  @confirm="router.delete(routes.admin_sys_role(row.id))">
                  <template #reference>
                    <el-button link type="danger">{{ $t('common.delete') }}</el-button>
                  </template>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="mt-2 flex justify-end border-t pt-[20px]">
        <el-pagination
          v-model:currentPage="pagination.current"
          v-model:page-size="pagination.pageSize"
          :page-sizes="[10, 20, 30, 40, 50]"
          layout="sizes, prev, pager, next, jumper, total"
          :total="pagination.total"
          @current-change="(current) => eventHandler('changePage', { page: current })"
          @size-change="(size) => eventHandler('changePageSize', { size: size })"
        />
      </div>
    </div>

    <template #drawer>
      <Drawer :options="options" ref="drawerRef" @close="adminLayout.closeDrawer()" />
    </template>
  </AdminLayout>
</template>

<script setup>
import AdminLayout from "@/layouts/Admin.vue"
import { Head } from "@inertiajs/vue3"
import Drawer from "./components/Drawer.vue"
import { Search, RefreshRight, Plus } from '@element-plus/icons-vue'

const { t } = useI18n()
const { triggerFlash } = useFlash()
const adminLayout = ref(null)
const drawerRef = ref(null)

const { loading, pagination, updatePagination, searchModel, queryData, eventHandler } = useSearch(routes.admin_sys_roles(), {
  keyword: "",
  page: 1,
  size: 20,
})

const props = defineProps({
  flash: Object,
  pagy: Object,
  rows: Array,
  options: Object
})

updatePagination(props.pagy)

const openDrawer = async (drawerMode, id = 0) => {
  adminLayout.value.openDrawer()
  await nextTick()
  console.log(drawerRef.value)
  if (drawerRef.value) {
    await drawerRef.value.updateDrawerMode(drawerMode, id)
    adminLayout.value.stopDrawerLoading()
  }
}

watchEffect(() => { if (props.flash) { triggerFlash(props.flash) } })

// 替换 Message 组件为 ElMessage
const Message = {
  error: (message) => ElMessage.error(message)
}
</script>
